var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M12 12V3a9 9 0 11-6.364 15.364"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }